<template>
  <div v-if="show" class="footer">
    <div class="w1200 container">
      <div class="container-left">
        <logo class="logo" :height="40"></logo>
      </div>
      <div class="fun-container">
        <div class="title">JOIN THE COMMUNITY</div>
        <div class="fun-list">
          <div class="fun-item" v-for="item, index in communities" :key="index">
            <a :href="item.url" :title="item.title">
              <i :class="['iconfont', `icon-${item.title}`]"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
      <div class="w1200 copyright">
        <div class="text-container">
          <p class="text">Copyright© 2022-2023 Eaglemask. All Rights Reserved.</p>
        </div>
      </div>
    </div>
</template>

<script>
import logo from '@/components/logo.vue'
import { getCommunities } from '@/utils/func'

export default {
  name: 'pageFooter',
  components: {
    logo
  },
  data () {
    return {
      show: true,
      list: [
        { title: 'PRODUCT', subList: ['Download', 'State'] },
        { title: 'COMPANY', subList: ['About', 'job offer', 'Brand Promotion'] },
        { title: 'RESOURCES', subList: ['Schoolyard', 'Technical Support', 'Security', 'Blog', 'Feedback', 'Developers'] },
        { title: 'POLICY', subList: ['Clause', 'Privacy', 'A Cookie Is Set', 'COP', 'Feedback', 'Developers'] }
      ]
    }
  },

  computed: {
    communities () {
      return getCommunities()
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('~@/scss/iconfont.scss');

.footer{
  border-top: 1px solid #eef;
  min-width: 1200px;
  background: linear-gradient(#FBFBFF, #E9EAFF);
  height: 160px;
  overflow: hidden;

  .container {
    height: 120px;
    padding-top: 24px;
    display: flex;

    .container-left {
      flex: 1;
      text-align: left;

      .logo {
        height: 48px;
      }
    }

    .fun-container{
      width: 220px;
      text-align: left;
      .title {
      }

      .fun-list{
        display: flex;
        justify-content: space-between;

        .fun-item{

          a{
            color: #555;
            color: rgba(0, 0, 0, 0.65);
            color: $blueOth;
          }

          .iconfont{
            font-size: 28px;

            &:hover{
              opacity: 0.6;
            }
          }
        }
      }
    }

  }
  .copyright{
    font-size: 12px;

    .text-container {
      display: flex;
      justify-content: space-between;

      .items {
        margin-right: 40px;
        a {
          color: #2C3E50;
          &:last-child {
            margin-left: 16px;
          }
          &:hover {
            color: $blueOth;
          }
        }
     }
    }
  }

  @media screen  and (max-width: $mobileWidth){
      min-width: 0;
      height: auto;
      .container{
        display: block;
        width: 100%;
        height: auto;

        .logo{
          ::v-deep img{
            height: 28px !important;
          }
        }
        .container-left{
          text-align: center;
        }

        .fun-container{
          text-align: center;
          margin: auto;
          .fun-list .fun-item .iconfont {
            font-size: 20px;
          }
        }
      }

      .copyright{
        margin-top: 12px;
        .text-container {
          flex-direction: column-reverse;
          justify-content: space-between;

        .items {
            margin-bottom: 12px;
            margin-right: 0;
          }
        }
      }
  }

}
</style>
